import { cn } from '@/shared/lib/cn';
import { useUnfinishedCount } from './useJobsTree';

interface Props {
  open: boolean;
  onClick: () => void;
}

export function JobsTrigger({ open, onClick }: Props) {
  const count = useUnfinishedCount();
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={open ? 'Close jobs' : 'Open jobs'}
      className={cn(
        'fixed bottom-5 right-5 z-40 flex h-12 items-center gap-2 rounded-full px-4 text-sm font-medium shadow-lg transition-colors',
        'border border-border bg-background hover:bg-muted',
      )}
    >
      <span aria-hidden>{open ? '×' : '⚙'}</span>
      <span>Jobs</span>
      {count > 0 ? (
        <span className="ml-1 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-amber-500/30 px-1.5 text-xs text-amber-200">
          {count}
        </span>
      ) : null}
    </button>
  );
}
